import Api from '../../shared/Api';
import {
    CustomerAgreement,
    CustomerAgreementAssignment,
    CustomerAgreementCustomer,
    CustomerAgreementInput,
    UpdateCustomerAgreementInput,
    CustomerAgreementLanguage,
    DeactivationImpact,
    CustomerAgreementListItem
} from './types';

const assignmentPathByKind = {
    'broker-firm': 'broker-firms',
    'broker-chain': 'broker-chains'
};

function assignmentPath(customer: CustomerAgreementCustomer): string {
    return `/views/customer-agreement-assignments/${assignmentPathByKind[customer.kind]}/${
        customer.id
    }`;
}

export class CustomerAgreementsApi {
    static async getAssignment(
        customer: CustomerAgreementCustomer
    ): Promise<CustomerAgreementAssignment> {
        return new Api().get(assignmentPath(customer));
    }

    static async assign(
        customer: CustomerAgreementCustomer,
        customerAgreementId: number | null
    ): Promise<CustomerAgreementAssignment> {
        return new Api().put(assignmentPath(customer), { customerAgreementId });
    }

    static async getAllCustomerAgreements(): Promise<CustomerAgreementListItem[]> {
        return new Api().get('/views/customer-agreements');
    }

    static async getLanguages(): Promise<CustomerAgreementLanguage[]> {
        return new Api().get('/views/customer-agreements/languages');
    }

    static async getDeactivationImpact(id: number): Promise<DeactivationImpact> {
        return new Api().get(`/views/customer-agreements/${id}/usage`);
    }

    static async getCustomerAgreement(id: number): Promise<CustomerAgreement> {
        return new Api().get(`/views/customer-agreements/${id}`);
    }

    static async createCustomerAgreement(
        input: CustomerAgreementInput
    ): Promise<CustomerAgreement> {
        return new Api().post('/views/customer-agreements', input);
    }

    static async updateCustomerAgreement(
        id: number,
        input: UpdateCustomerAgreementInput
    ): Promise<CustomerAgreement> {
        return new Api().put(`/views/customer-agreements/${id}`, input);
    }
}
